module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD_45.ec49ad6b.svg";